import { useFlag } from '@calendly/feature-check-react'
import styled from 'astroturf/react'
import { CalendlyLogo as CalendlyLogoRefreshed } from '@calendly/ui/components/calendly-logo'
import { CalendlyLogo } from '@calendly/ui/components/wordmark-logo'
import _LogoSizeWrapper from "brand_logo-LogoSizeWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/brand_logo.js?styleId=LogoSizeWrapper";
import _LegacyLogoTint from "brand_logo-LegacyLogoTint.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/brand_logo.js?styleId=LegacyLogoTint";

const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'

const LogoSizeWrapper = /*#__PURE__*/styled('span', null, {
  displayName: "LogoSizeWrapper",
  styles: _LogoSizeWrapper
})

const LegacyLogoTint = /*#__PURE__*/styled('span', null, {
  displayName: "LegacyLogoTint",
  styles: _LegacyLogoTint
})

export const BrandLogo = ({ size = '20px', tintLegacy = false }) => {
  const productRefreshLogo = useFlag('ap_product_refresh_2026_company_logo', false)

  if (productRefreshLogo) {
    return (
      <LogoSizeWrapper style={{ height: size }} data-testid="brand-logo">
        <CalendlyLogoRefreshed variant="fullLockup" color="oneColor" aria-label="Calendly" />
      </LogoSizeWrapper>
    )
  }

  const legacyLogo = <CalendlyLogo alt="Calendly" color={colorTextSecondary} />

  return (
    <LogoSizeWrapper style={{ height: size }} data-testid="brand-logo">
      {tintLegacy ? <LegacyLogoTint>{legacyLogo}</LegacyLogoTint> : legacyLogo}
    </LogoSizeWrapper>
  )
}
